export default __webpack_public_path__ + "static/media/logout.c98da4be.svg";